import styled from 'shared/utils/styled';

export const BorderedBox = styled('div')(({ theme }) => ({
  padding: '15px 25px',
  background: 'rgb(255, 255, 255)',
  borderLeft: `5px solid ${theme.palette.primary.main}`,
  borderRadius: 2,

  [theme.breakpoints.down('md')]: {
    padding: '15px 10px',
  },
}));
